import React from 'react';
import { FooterStyled } from './styles';
import { FaWhatsapp, FaInstagram, FaFacebookF, FaTiktok } from "react-icons/fa";

const Header = () => {

    const handleGoto = (target) => {

        let url = "";
        switch (target) {
            case "instagram":
                url = "https://www.instagram.com/mercadoruralargentino/";
                break;
            case "tiktok":
                url = "https://www.tiktok.com/@mercado.rural";
                break;
            default:
                break;
        }
        window.open(url, '_blank');
        //
    }

    const openWhatsApp = (phone, text = "") => {
        // limpia el número y genera la URL compatible con wa.me
        const clean = phone.replace(/\D/g, ""); // elimina todo lo que no sea dígito
        const url = `https://wa.me/${clean}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
        window.open(url, "_blank");
    }

    return (
        <FooterStyled>
            <div className='logo_footer'>
                <img src='/images/logo_white.svg' />
            </div>
            {/* <div className='contacto'>
                <p className='text_amarillo_banana'>Si tenés alguna consulta escribinos a:</p>
                <p className='email text_blanco_huevo'>mercadoruralarg@gmail.com</p>
            </div> */}
            <div className='contacto'>
                <p className='email text_blanco_huevo'>Seguinos para ver el calendario de actividades y mantenerte informado.</p>
            </div>
            <div className='social'>
                <div className='bt_instagram' onClick={() => handleGoto("instagram")}>
                    <FaInstagram />
                </div>
                <div className='bt_facebook' onClick={() => handleGoto("tiktok")}>
                    <FaTiktok />
                </div>
            </div>
            <div className='direccion text_blanco_huevo'>Av. Tte. Gral. Donato Álvarez 175</div>

            {/* <div 
                className='wp_contact'
                onClick={() => openWhatsApp("+54 9 11 2473-4769", "Hola")} 
            >
                <div className='wp_icon'>
                    <FaWhatsapp />
                </div>
                <div className='wp_numero'>+54 9 11 2473-4769</div>
            </div> */}

            <div className='wp_numero'>+54 9 11 2473-4769</div>

        </FooterStyled>
    );
};

export default Header;